import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiosk');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-kiosk',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.kiosk/view.scss */
:host {
  display: block;
  height: 100%;
}

.status-pulse {
  animation: breathe 3s ease-in-out infinite;
}

.status-glow {
  animation: breathe 3s ease-in-out infinite;
}

@keyframes breathe {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.08);
  }
}
.panel-slide {
  transform: translateX(100%);
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.panel-slide.panel-open {
  transform: translateX(0);
}`],
})
export class PageKioskComponent implements OnInit, OnDestroy {
    public currentStatus: string = 'in';
    public currentTime: string = '';
    public currentDate: string = '';
    public panelOpen: boolean = false;
    private timer: any;

    public statuses: any[] = [
        { key: 'in', label: '재실', subtitle: '자리에 계십니다', bg: 'bg-emerald-500', icon: 'check' },
        { key: 'out', label: '외출', subtitle: '외출 중입니다', bg: 'bg-sky-500', icon: 'walk' },
        { key: 'away', label: '부재중', subtitle: '자리를 비우셨습니다', bg: 'bg-zinc-500', icon: 'clock' },
        { key: 'off', label: '퇴근', subtitle: '퇴근하셨습니다', bg: 'bg-zinc-800', icon: 'moon' },
        { key: 'meeting-in', label: '내부회의', subtitle: '내부 회의 중입니다', bg: 'bg-amber-500', icon: 'users' },
        { key: 'meeting-out', label: '외부회의', subtitle: '외부 회의 중입니다', bg: 'bg-rose-500', icon: 'building' },
        { key: 'trip', label: '출장', subtitle: '출장 중입니다', bg: 'bg-violet-600', icon: 'plane' },
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.updateTime();
        this.timer = setInterval(async () => {
            this.updateTime();
            await this.service.render();
        }, 10000);
        await this.loadStatus();
    }

    public ngOnDestroy() {
        if (this.timer) clearInterval(this.timer);
    }

    private updateTime() {
        const now = new Date();
        const days = ['일', '월', '화', '수', '목', '금', '토'];
        this.currentDate = `${now.getFullYear()}. ${String(now.getMonth() + 1).padStart(2, '0')}. ${String(now.getDate()).padStart(2, '0')}. (${days[now.getDay()]})`;
        this.currentTime = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
    }

    get status() {
        return this.statuses.find((s: any) => s.key === this.currentStatus) || this.statuses[0];
    }

    public async loadStatus() {
        const { code, data } = await wiz.call("get_status");
        if (code === 200) {
            this.currentStatus = data.status || 'in';
        }
        await this.service.render();
    }

    public async togglePanel() {
        this.panelOpen = !this.panelOpen;
        await this.service.render();
    }

    public async setStatus(key: string) {
        if (this.currentStatus === key) {
            this.panelOpen = false;
            await this.service.render();
            return;
        }
        this.currentStatus = key;
        this.panelOpen = false;
        await this.service.render();
        await wiz.call("set_status", { status: key });
    }
}

export default PageKioskComponent;